module.exports = __webpack_public_path__ + "img/sote.f1043f33.png";